import { render } from "./ConfirmAppointmentView.vue?vue&type=template&id=25c4c2ca&scoped=true"
import script from "./ConfirmAppointmentView.vue?vue&type=script&lang=js"
export * from "./ConfirmAppointmentView.vue?vue&type=script&lang=js"

import "./ConfirmAppointmentView.vue?vue&type=style&index=0&id=25c4c2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c4c2ca"]])

export default __exports__